export default {
  title: "Документы",
  titleLarge: 'Документы от АО "ЭКСПОЦЕНТР"',
  notification:
    "Распечатайте акты в двух экземплярах, подпишите и поставьте печать организации. Возьмите подписанные акты на выставку для обмена закрывающими документами.",
  issuedInvoices: "Договоры и счета",
  acts: "Акты оказанных услуг",
  titleStatusPay: "Статус оплаты",
  invoiceNumber: "№ Счёта",
  invoiceLocation: {
    part1: "Счета от уполномоченных партнеров можно скачать в разделе",
    part2: "Мои заказы."
  },
  contractNumber: "№ Договора",
  contractNumberAndDate: "№ и дата договора",
  numberAct: "№ Акта",
  date: "Дата",
  invoiceAmount: "Сумма счёта",
  sumAct: "Сумма акта",
  sum: "Сумма",
  downloadFile: "Скачать файл",
  downloadFileShort: "Скачать",
  copyFile: "Скопировать",
  printFile: "Распечатать",
  showFile: "Посмотреть",
  deleteFile: "Удалить",
  collapse: "Свернуть",
  more: "Подробнее",
  number: "№",
  status: "Статус",
  paid: "Оплачено",
  contractNumberAndDateContent: "{number} от {date}",
  invoiceDateNumber: "Счет на оплату №{number} от {date}",
  downloadForm1: "Скачайте форму доверенности",
  downloadForm2: "здесь",
  edoExchange: "Обмен в ЭДО",
  edoSettings: "Настройки ЭДО"
};
